const ProductTaxonomyPLMUI = (props: {
  productDevId: any;
  seasonNumber: any;
  accessToken: string;
}) =>{
  return (
    <div>
      <h3>Product Taxonomy – Under Development</h3>
    </div>
  );
};
export default ProductTaxonomyPLMUI;
